import { useEffect, useState } from "react";
import { useCollectionData } from "react-firebase-hooks/firestore";
import { useHistory } from "react-router-dom";
import { db } from "../firebase";

const cardStyle = {
  backgroundImage: "url(/web.jpg)",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
};
const Button = ({ children,onClick }) => {
  return (
    <button onClick={onClick} className="w-max max-w-full hover:bg-darkblue  bg-blue text-white p-2 text-sm">
      {children}
    </button>
  );
};
const Account = ({ uid }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(false);
  const [canceling, setCanceling] = useState(false);
  const query = db.collection("pending_orders").where("user", "==", uid);
  const [orders, loadingOrders, error] = useCollectionData(query, {
    idField: uid,
  });
  const history = useHistory();
  useEffect(() => {
    if (orders) {
      console.log(orders);
    }
  }, [orders]);
  useEffect(() => {
    setLoading(true);
    if (uid) {
      db.collection("users")
        .doc(uid)
        .get()
        .then((doc) => {
          setUser(doc.data());
          setLoading(false);
        })
        .catch((err) => {
          alert(
            "Something happened while fetching data. If this happens continuesly please contact us. Redirecting..."
          );
          history.push("/sign-in");
          setLoading(false);
        });
    }
  }, [uid]);

  return (
    <div className="flex flex-col w-full overflow-y-auto h-full">
      {user && (
        <div className="py-12  w-full">
          <div className="text-2xl  w-full sm:text-3xl font-bold">
            {user.name}
          </div>
          <div className="text-lg  w-full">
            From {user.city}, {user.country}
          </div>
          <div className="mt-12  w-full">
            <div className="text-lg sm:text-xl  w-full mb-8">
              You have bought no websites yet
            </div>
          </div>
          {orders && (
            <div className="mt-12  w-full">
              <div className="text-lg sm:text-xl  w-full mb-8">
                {orders.length === 0
                  ? "You have no pending orders yet"
                  : orders.length === 1
                  ? "You have one pending order"
                  : `You have ${orders.length} pending orders`}
              </div>
              <div className="flex w-full flex-col">
                {orders.map((order) => (
                  <div
                    className="flex items-center mb-8 flex-wrap max-w-sm justify-between w-full"
                    key={order.website}
                  >
                    <div className="flex items-center gap-8">
                      <div className="">{order.title}</div>
                      <div className="font-bold">{order.price}$</div>
                    </div>
                    <Button
                      onClick={() => {
                        setCanceling(true);
                        db.collection("websites")
                          .doc(order.website)
                          .update({
                            payment_pending: false,
                          })
                          .then(() => {
                            db.collection("pending_orders").doc(order.id).delete().then(()=>{
                              setCanceling(false);
                              alert(
                                "Order cancelled successfully."
                              );

                            })
                            history.push("/");
                          })
                          .catch((err) => {
                            console.log(err);
                            setCanceling(false);
                            alert(
                              "Something happened while cancelling order. If this happens continuesly please contact us. Redirecting..."
                            );
                          });
                      }}
                    >
                      Cancel
                    </Button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
      )}
      {loading && <p className="text-base w-full italic mt-4">Loading...</p>}
      {canceling && <p className="text-base w-full italic mt-4">Cancelling order...</p>}
    </div>
  );
};

export default Account;
